import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=fff6f5bc&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=fff6f5bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff6f5bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff6f5bc')) {
      api.createRecord('fff6f5bc', component.options)
    } else {
      api.reload('fff6f5bc', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=fff6f5bc&scoped=true", function () {
      api.rerender('fff6f5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/TextWidget.vue"
export default component.exports